export default function VendorResourceDirective() {
  return {
    template: require('./vendor-resource.html'),
    scope: {
      vendorResource: '=',
      canDelete: '<',
    },
    controller: 'VendorResourceController',
    controllerAs: 'vendorResourceVM',
    bindToController: true,
    replace: true,
  };
}
